// extracted by mini-css-extract-plugin
export default {"scrollToTopBtn":"scroll-to-top_scrollToTopBtn__Ei5tc"};